import { Heading, Icon, Text } from '@nexa/ui';

export interface SecurityCardProps {
  readonly icon: 'server' | 'key-round' | 'scroll-text' | 'shield-check';
  readonly title: string;
  readonly body: string;
}

/**
 * Card trên nền tối của `#security` (`template.html:1004`).
 *
 * `h-full` là BẮT BUỘC ở cả đây lẫn lớp `Reveal` bọc ngoài: `Reveal` render một `div` nên NÓ mới
 * là ô grid, còn card là con của ô. Thiếu `h-full` ở một trong hai lớp thì card ngắn hơn ô và
 * **hở đáy** — jsdom không bắt được vì nó không chạy layout engine, và `design:diff` chỉ đo ở
 * 1440 nên hàng cuối có thể không lộ.
 *
 * Tiêu đề card dùng `Heading` bậc `title-bold` — 16px/700, đúng số đo `:1004` của bản thiết kế.
 *
 * Trước vé #10 chỗ này là `<h3>` viết trần, vì `Heading` chỉ có bậc `title` khoá cứng 600 và
 * `Heading` là vùng đóng băng với lô D (nợ **D-4**, quyết định của user 2026-08-20). Bậc thứ hai
 * đã được thêm ở vé #10 nên thẻ trần không còn lý do tồn tại.
 *
 * ⚠️ Đường "chữa" trông hợp lý mà SAI, đừng quay lại nó: truyền weight qua `className` của
 * `Heading` đặt hai utility cùng thuộc tính cạnh nhau, và `cn()` chỉ nối chuỗi chứ không phải
 * tailwind-merge ⇒ thắng thua do thứ tự Tailwind xếp trong CSS, không do thứ tự ta viết.
 */
export function SecurityCard({ icon, title, body }: SecurityCardProps) {
  return (
    <div className="h-full rounded-card border border-[var(--on-dark-line-14)] p-6">
      <Icon name={icon} size={20} className="text-accent" />
      <Heading level={3} size="title-bold" tone="on-dark" className="mt-[14px]">
        {title}
      </Heading>
      <Text size="body-sm" tone="on-dark-soft" className="mt-2">
        {body}
      </Text>
    </div>
  );
}
